<template>
  <div>
    <a-modal
      title="上传图片"
      :visible="isHide"
      :maskClosable="false"
      :width="'80vw'"
      centered
      :footer="null"
      @cancel="cancelHandel"
    >
      <div class="cropper-content">
        <div class="cropper-box">
          <div style="width: 500px">
            <a-row style="marign-top: 20px">
              <a-col :lg="4" :md="4">
                <a-upload name="file" :accept="'image/*'" :beforeUpload="selectImg" :showUploadList="false">
                  <a-button icon="upload">选择图片</a-button>
                </a-upload>
                <!-- <label class="btn" for="uploads">选择图片</label>
          <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)"> -->
              </a-col>
              <a-col :lg="{ span: 1, offset: 2 }" :md="2">
                <a-button icon="plus" @click="changeScale(1)" />
              </a-col>
              <a-col :lg="{ span: 1, offset: 1 }" :md="2">
                <a-button icon="minus" @click="changeScale(-1)" />
              </a-col>
              <a-col :lg="{ span: 1, offset: 1 }" :md="2">
                <a-button icon="undo" @click="rotateLeft" />
              </a-col>
              <a-col :lg="{ span: 1, offset: 1 }" :md="2">
                <a-button icon="redo" @click="rotateRight" />
              </a-col>
              <a-col :lg="{ span: 2, offset: 6 }" :md="2">
                <a-button type="primary" :loading="uploading" @click="uploadImg('blob')">保存</a-button>
              </a-col>
            </a-row>
          </div>
          <div class="cropper">
            <vue-cropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.outputSize"
              :outputType="option.outputType"
              :info="option.info"
              :canScale="option.canScale"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :full="option.full"
              :fixedBox="option.fixedBox"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :centerBox="option.centerBox"
              :height="option.height"
              :infoTrue="option.infoTrue"
              :maxImgSize="option.maxImgSize"
              :enlarge="option.enlarge"
              :mode="option.mode"
              @realTime="realTime"
              @imgLoad="imgLoad"
            >
            </vue-cropper>
          </div>
          <!--底部操作工具按钮-->

          <!-- <div class="scope-btn">
          <label class="btn" for="uploads">选择图片</label>
          <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
          <a-button icon="plus" @click="changeScale(1)">放大</a-button>
          <a-button icon="minus" @click="changeScale(-1)">缩小</a-button>
          <a-button icon="undo" @click="rotateLeft">↺ 左旋转</a-button>
          <a-button size="mini" @click="rotateRight">↻ 右旋转</a-button>
        </div>
        <div class="upload-btn">
          <a-button type="primary" @click="uploadImg('blob')">上传封面 <i class="el-icon-upload"></i></a-button>
        </div> -->
        </div>
        <!--预览效果图-->
        <div class="show-preview">
          <div :style="previews.div" :class="previews.url ? 'preview previewBorder' : 'preview'">
            <img :src="previews.url" :style="previews.img" />
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as imageConversion from 'image-conversion'
import { sysOssUpload } from '@/api/system/upload'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'CropperImage',
  data () {
    return {
      previews: {},
      ossUrl: process.env.VUE_APP_OSS_URL,
      uploadImgUrl: process.env.VUE_APP_BASE_URL + '/system/oss/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*'
      },
      originalImg: {},
      uploading: false,
      option: {
        img: '', // 裁剪图片的地址
        outputSize: 0.7, // 裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'png', // 裁剪生成图片的格式（jpeg || png || webp）
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 990, // 默认生成截图框宽度
        autoCropHeight: 350, // 默认生成截图框高度
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [2.8, 1], // 截图框的宽高比例
        full: false, // false按原比例裁切图片，不失真
        fixedBox: true, // 固定截图框大小，不允许改变
        canMove: false, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        height: true, // 是否按照设备的dpr 输出等比例图片
        infoTrue: false, // true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, // 限制图片最大宽度和高度
        enlarge: 1 // 图片根据截图框输出比例倍数
      }
    }
  },
  props: {
    skType: {
      // 实勘类型1视频 2本铺 3内部 4平面 5周边
      type: String,
      default: ''
    },
    isHide: {
      type: Boolean,
      default: false
    },
    fList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    fList: function (val) {
      console.log(val)
      this.fileList = val
    }
  },
  methods: {
    // 初始化函数
    imgLoad (msg) {
      console.log('工具初始化函数=====' + msg)
    },
    // 图片缩放
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    // 向左旋转
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    // 向右旋转
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    // 实时预览函数
    realTime (data) {
      this.previews = data
    },
    // 选择图片
    selectImg (file) {
      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(file.name)) {
        this.$message.error('图片类型要求：jpeg、jpg、png')
        return false
      }
      this.originalImg = file
      // 转化为blob
      const reader = new FileReader()
      // reader.onload = (e) => {
      //   let data
      //   if (typeof e.target.result === 'object') {
      //     data = window.URL.createObjectURL(new Blob([e.target.result]))
      //   } else {
      //     data = e.target.result
      //   }
      //   this.option.img = data
      // }
      // // 转化为base64
      // reader.readAsDataURL(file)
      reader.readAsDataURL(file)
      if (file.size < 2 * 1024 * 1024) {
        reader.onload = () => {
          this.option.img = reader.result
        }
      } else {
        reader.onload = async () => {
          const datas = await imageConversion.compressAccurately(file, 2048)

          const baseps = await imageConversion.filetoDataURL(datas)
          this.option.img = baseps
        }
      }

      return false
    },
    // 关闭裁剪弹窗
    cancelHandel () {
      this.option.img = ''
      this.$emit('cancelHandel')
    },
    // 上传图片
    uploadImg (type) {
      this.uploading = true
      const formData = new FormData()
      // 输出
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob((data) => {
          const img = window.URL.createObjectURL(data)
          this.model = true
          this.modelSrc = img
          formData.append('file', data, this.originalImg.fileName)
          sysOssUpload(formData).then((response) => {
            this.open = false
            this.$message.success('上传成功')
            const fileObj = {}
            if (response && typeof response.data !== 'undefined') {
              const fData = response.data
              fileObj.name = fData.fileName
              fileObj.status = 'done'
              fileObj.response = { code: 200, data: { ossId: fData.ossId }, msg: '操作成功' }
              fileObj.uid = fData.ossId
              fileObj.url = process.env.VUE_APP_OSS_URL + fData.fileName
            }
            this.cancelHandel()
            this.option.img = ''
            this.$emit('uploadImgSuccess', fileObj, this.skType)
          })
        })
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.model = true
          this.modelSrc = data
        })
      }
      if (!this.option.img) {
        this.$message.error('图片不能为空')
      }
      setTimeout(() => {
        this.uploading = false
      }, 500)
    }
  }
}
</script>

<style scoped lang="less">
.cropper-content {
  display: flex;
  flex-direction: column;
  display: -webkit-flex;
  justify-content: flex-end;
  .cropper-box {
    flex: 1;
    width: 100%;
    .cropper {
      width: auto;
      height: 400px;
      margin-top: 10px;
    }
  }

  .show-preview {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;

    .preview {
      overflow: hidden;
      height: 350px !important;
    }
  }
}
.previewBorder {
  border: 1px solid #67c23a;
  background: #cccccc;
}
.footer-btn {
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  .scope-btn {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    padding-right: 10px;
  }
  .upload-btn {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
  }
  .btn {
    outline: none;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    font-weight: 500;
    padding: 8px 15px;
    font-size: 12px;
    border-radius: 3px;
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    margin-right: 10px;
  }
}
</style>
